import React, {useState} from "react";

import {useNavigate} from 'react-router-dom';
import {MenuBuilder} from "../../components/menu/MenuBuilder";

const EquipmentPage = ({}) => {
    const navigate = useNavigate();
    let user = JSON.parse(localStorage.getItem("user"));

    let menu = [
        {auth: "TKendaraan", name: "Transaksi Kendaraan", path: "/equipment/kendaraan"},

    ]
    let Report = [
        {auth: "TMKendaraan", name: "Monitoring Kendaraan", path: "/equipment/monitoring/kendaraan"},
        {auth: "TRKendaraan", name: "Pemakaian Kendaraan", path: "/equipment/report/kendaraan"},

    ]
    const [listMenu, setListMenu] = useState(menu);
    const [listReport, setListReport] = useState(Report);

    const filterMenu = (event) => {
        const filtered = menu.filter(
            ({name}) => name.toLowerCase().includes(event.target.value.toLowerCase())
        )
        setListMenu(filtered)
    }
    const filterReport = (event) => {
        const filtered = Report.filter(
            ({name}) => name.toLowerCase().includes(event.target.value.toLowerCase())
        )
        setListReport(filtered)
    }
    return (
        <div className="md:ml-64">
            <div className="w-full flex flex-col items-center">
                <div className="w-full px-4 my-4 ">
                    <MenuBuilder name="Transaction" menuController={filterMenu} listMenu={listMenu}/>
                    <hr className={"border border-main-100 my-6"}/>
                    <MenuBuilder name="Report" menuController={filterReport} listMenu={listReport}/>
                </div>
            </div>
        </div>
    );
};

export default EquipmentPage;
